import './StyleGuide.css';

import React from 'react'

function SizeGuide() {
  return (
    <div id="elements">
        <div className="style_header">Size</div>
        <div className='sizes'>
            <div className='medium'> The font sizes used in the application range from 14 to 55 pixels </div>
            <p className='medium'> Smaller sizes are mostly used for button and overall text in the application. </p>
            <p className='medium'>Larger sizes are used for headings and important messages on the main screen.</p> 
            <div className='medium'> Other examples of font sizes we use are:</div>
                <ul className='size_list'>
                    <li className="style_s">Font Size: Small</li>
                    <li className="style_m">Font Size: Medium</li>
                    <li className="style_l">Font Size: Large</li>
                    <li className="style_xl">Font Size: X-Large</li>
                    <li className="style_xxl">Font Size: XX-Large</li>
                </ul>
            <p className='medium'></p>
        </div>
    </div>
  )
}

export default SizeGuide